import type { Options, UnitTranslationOptions } from 'humanize-duration';
import { useMemo } from 'react';
import humanizeDuration from 'humanize-duration';
import { I18n } from '~/common/explicit-exports';

const shortEn: UnitTranslationOptions = {
  y: () => 'y',
  mo: () => 'mo',
  w: () => 'w',
  d: () => 'd',
  h: () => 'h',
  m: () => 'm',
  s: () => 's',
  ms: () => 'ms',
};

export interface DurationFormatterOptions extends Options {
  short?: boolean;
}

export function useDurationFormatter(options: DurationFormatterOptions = {}) {
  let language = I18n.currentLocale().split('_')[0];

  if (options.short) {
    // Only short english is supported currently
    language = language === 'en' ? 'shortEn' : language;
  }

  return useMemo(
    () =>
      humanizeDuration.humanizer({
        language,
        languages: { shortEn },
        fallbacks: ['en'],
        ...options,
      }),
    [language, options],
  );
}
